module.exports = __webpack_public_path__ + "static/media/outdated-warning.7b438f3c.svg";